"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMCOSCSettingsT = exports.VMCOSCSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const oscsettings_js_1 = require("../../solarxr-protocol/rpc/oscsettings.js");
/**
 * OSC Settings specific to VMC
 */
class VMCOSCSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVMCOSCSettings(bb, obj) {
        return (obj || new VMCOSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVMCOSCSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VMCOSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    oscSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new oscsettings_js_1.OSCSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    vrmJson(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    anchorHip() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    mirrorTracking() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startVMCOSCSettings(builder) {
        builder.startObject(4);
    }
    static addOscSettings(builder, oscSettingsOffset) {
        builder.addFieldOffset(0, oscSettingsOffset, 0);
    }
    static addVrmJson(builder, vrmJsonOffset) {
        builder.addFieldOffset(1, vrmJsonOffset, 0);
    }
    static addAnchorHip(builder, anchorHip) {
        builder.addFieldInt8(2, +anchorHip, +false);
    }
    static addMirrorTracking(builder, mirrorTracking) {
        builder.addFieldInt8(3, +mirrorTracking, +false);
    }
    static endVMCOSCSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createVMCOSCSettings(builder, oscSettingsOffset, vrmJsonOffset, anchorHip, mirrorTracking) {
        VMCOSCSettings.startVMCOSCSettings(builder);
        VMCOSCSettings.addOscSettings(builder, oscSettingsOffset);
        VMCOSCSettings.addVrmJson(builder, vrmJsonOffset);
        VMCOSCSettings.addAnchorHip(builder, anchorHip);
        VMCOSCSettings.addMirrorTracking(builder, mirrorTracking);
        return VMCOSCSettings.endVMCOSCSettings(builder);
    }
    unpack() {
        return new VMCOSCSettingsT((this.oscSettings() !== null ? this.oscSettings().unpack() : null), this.vrmJson(), this.anchorHip(), this.mirrorTracking());
    }
    unpackTo(_o) {
        _o.oscSettings = (this.oscSettings() !== null ? this.oscSettings().unpack() : null);
        _o.vrmJson = this.vrmJson();
        _o.anchorHip = this.anchorHip();
        _o.mirrorTracking = this.mirrorTracking();
    }
}
exports.VMCOSCSettings = VMCOSCSettings;
class VMCOSCSettingsT {
    constructor(oscSettings = null, vrmJson = null, anchorHip = false, mirrorTracking = false) {
        this.oscSettings = oscSettings;
        this.vrmJson = vrmJson;
        this.anchorHip = anchorHip;
        this.mirrorTracking = mirrorTracking;
    }
    pack(builder) {
        const oscSettings = (this.oscSettings !== null ? this.oscSettings.pack(builder) : 0);
        const vrmJson = (this.vrmJson !== null ? builder.createString(this.vrmJson) : 0);
        return VMCOSCSettings.createVMCOSCSettings(builder, oscSettings, vrmJson, this.anchorHip, this.mirrorTracking);
    }
}
exports.VMCOSCSettingsT = VMCOSCSettingsT;
